import React from 'react';
import { Button } from 'react-admin';
import { Link } from 'react-router-dom';
import ChatBubbleIcon from '@material-ui/icons/RemoveCircleTwoTone';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    button: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1)
    }
  }));

const RemovePointsButton = ({ record }) => {
    const classes = useStyles();
  
    return (
      <Button className={classes.button} 
            variant="contained"
            component={Link}
            to={{
                pathname: '/customer/create',
                state: { record: { merchant_id: record.merchantId, email: record.email, name: record.name, addRemove: false } }
            }}>
        <ChatBubbleIcon />
      </Button>
    );
};

export default RemovePointsButton;